/**
 * Import Lib & assets
 */

import React, { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { Form__tabulations, Form__questions, Form__submit } from "components/form/form";
import { Button__back } from "components/button/button";

/**
 * import context
 */
import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * styled components
 */

const Steps = styled.div``;

const BackButton = styled(Button__back)`
  ${t.mixins.sm(`
    display: none;
  `)}
`;

/**
 * steps component is..
 */

const Form__steps = ({ style, steps }) => {
  const { c } = useContext(ContentContext);
  const [error, setError] = useState(false);
  const isFilled = (answers, steps, index) => {
    let totalAnswers = 0;
    for (let i = 0; i <= index; i++) {
      totalAnswers += steps[i].questions.length;
    }
    return Object.keys(answers).length >= totalAnswers;
  };
  const { userAnswers, currentStep, setCurrentStep } = useContext(AppContext);
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;
  const history = useHistory();
  let resultsRef = useRef();

  const onSubmit = () => {
    if (isLastStep) {
      history.push("/products");
    } else {
      setCurrentStep(currentStep + 1);
    }
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView();
    }
  };

  const onError = () => {
    setError(true);
  };

  const filled = isFilled(userAnswers, steps, currentStep);

  useEffect(() => {
    if (filled) {
      setError(false);
    }
  });

  const back = () => {
    setCurrentStep(currentStep - 1);
  };

  const submitTitle = isLastStep
    ? c("home.form.submit")
    : `${c("home.form.step")} ${currentStep + 2}`;
  return (
    <Steps style={style}>
      <div ref={resultsRef}></div>
      {!isFirstStep && <BackButton title={`${c('home.form.step')} ${currentStep}`} onClick={back} />}
      <Form__tabulations steps={steps} active={currentStep} />
      <Form__questions questions={steps[currentStep].questions} error={error} />
      <Form__submit onSubmit={onSubmit} onError={onError} title={submitTitle} filled={filled} />
    </Steps>
  );
};
export default Form__steps;

Form__steps.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
  /**
      Every steps from the form
      */
  steps: PropTypes.arrayOf(PropTypes.shape({})),
};

Form__steps.defaultProps = {
  style: {},
  steps: [],
};
